// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__31BGA","detailsBorder":"styles_detailsBorder__EKmrY"};